<mat-icon
    class="tw-top-6 tw-right-9 tw-absolute tw-cursor-pointer"
    [mat-dialog-close]="true"
    >close</mat-icon
>

<div
    class="tw-pb-10 tw-mt-10 tw-bg-white tw-px-[3rem] tw-flex tw-flex-col landing-calc-form tw-justify-center tw-gap-6 tw-mx-auto tw-items-center tw-py-0"
>
    <div class="loan-no-input tw-flex tw-flex-col tw-bg-white tw-w-[13rem]">
        <label class="tw-text-base tw-font-[500] tw-mb-[5px]"
            >Loan Amount
        </label>
        <input
            type="email"
            [formControl]="emailFormControl"
            placeholder="30,000"
        />
    </div>
    <div class="loan-no-input tw-flex tw-flex-col tw-bg-white">
        <select-home
            class="tw-w-full"
            [options]="selectOptionYears"
            [label]="'Repayment Years'"
            [currentValue]="selectedRepaymentYearsValue"
            (selectionChange)="(handleSelectionChangeRepaymentYears)"
        />
    </div>
    <div class="loan-no-input tw-flex tw-flex-col tw-bg-white">
        <select-home
            class="tw-w-full"
            [options]="selectOptionsInterest"
            [label]="'Interest %'"
            [currentValue]="selectedInterestValue"
            (selectionChange)="(handleSelectionChangeInterest)"
        />
    </div>
    <div>
        <button
            class="tw-text-white tw-text-xl tw-py-[1.1rem] tw-basis-[50%] tw-whitespace-nowrap tw-rounded-[3rem] tw-px-[2.2rem] 2xl:tw-px-[2.5rem] tw-bg-gradient-to-r tw-from-[#FFA53C] tw-to-[#FFC53C]"
        >
            See the Breakdown
        </button>
    </div>
</div>
